import IAccount from './account.model';

export interface IAnnouncement {
  id: string;
  title: string;
  intro: string;
  bullets: string[];
  ctaLabel: string;
  ctaPath: string; // appended to /:accountId/
  shouldShow: (account: IAccount) => boolean;
}

export const announcements: IAnnouncement[] = [
  {
    id: 'code-repositories',
    title: 'Shipbook now fixes your issues — not just finds them',
    intro: 'Connect your GitHub repository and Shipbook\'s AI turns every error into a fix:',
    bullets: [
      'Loglytics issues and alerts arrive with the root cause in your code — and the fix, ready to apply.',
      'LogChat debugs with your actual source, then opens a pull request with the fix — you review and merge.',
    ],
    ctaLabel: 'Connect GitHub',
    ctaPath: 'preferences/code-repositories',
    shouldShow: account => !account.githubIntegration,
  },
];
